import { DateTime } from 'luxon';
import { getText } from 'context/language/getText';
import { DAYS_AGO_THRESHOLD } from './config';

export const getDurationString = (messageSentAt) => {
  const now = DateTime.now();
  const messageSentAtDateTime = DateTime.fromISO(messageSentAt);
  const differenceInDays = now.diff(messageSentAtDateTime, ['days']).as('days');

  // return timestamp if more than DAYS_AGO_THRESHOLD days ago
  if (differenceInDays > DAYS_AGO_THRESHOLD) {
    return messageSentAtDateTime.toLocaleString(DateTime.DATE_MED);
  }

  // return days if more than 0 days ago
  if (differenceInDays > 0) {
    return getText('header.messages.content.duration.days', {
      days: Math.ceil(differenceInDays)
    });
  }

  // return hours if less than 1 day ago
  const differenceInHours = now.diff(messageSentAtDateTime, ['hours']).as('hours');

  return getText('header.messages.content.duration.hours', {
    hours: Math.ceil(differenceInHours)
  });
};
